const { localStorage } = require('@fiverr-private/futile/lib/storage');

const LOCAL_STORAGE_KEY = 'browse-history',
    GIGS_REGEX = /gigs\|\|\|show\|\|\|([\d]+)/;

const getGigIds = () => getFromLocalStorageByRegex(GIGS_REGEX);

const getFromLocalStorageByRegex = (regexExp) => {
    let results = [];
    const userBrowseHistory = localStorage.get(LOCAL_STORAGE_KEY);

    if (userBrowseHistory) {
        results = userBrowseHistory.reduce((accumulator, data) => {
            const match = data.match(regexExp);
            if (match && match.length > 1) {
                accumulator.push(match[1]);
            }
            return accumulator;
        }, []);
    }

    return results;
};

module.exports = {
    LOCAL_STORAGE_KEY,
    getGigIds
};
